import React, { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './components/AuthContext';
import LandingPage from './components/LandingPage';
import LoginPage from './components/LoginPage';
import RegisterPage from './components/RegisterPage';
import Dashboard from './components/Dashboard';
import SubscriptionPage from './components/SubscriptionPage';
import GalleryPage from './components/GalleryPage';
import HowItWorksPage from './components/HowItWorksPage';
import BriefPage from './components/BriefPage';
import { Toaster } from 'sonner';
import './App.css';

function AppContent() {
  const { user, loading } = useAuth();
  const [view, setView] = useState('landing');
  const [inviteCode, setInviteCode] = useState('');

  // Check for invite/referral code in URL on mount
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const invite = params.get('invite');
    const ref = params.get('ref');
    if (invite) {
      setInviteCode(invite);
      setView('register');
    } else if (ref) {
      setInviteCode(ref);
      setView('register');
    }
  }, []);

  // Handle Stripe return URLs
  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes('/subscription/success') || path.includes('/subscription/cancel')) {
      if (user && user !== false) setView('subscription');
    }
  }, [user]);

  // Redirect after login
  useEffect(() => {
    if (user && user !== false) {
      setView(prev => {
        const path = window.location.pathname;
        if (path.includes('/subscription')) return 'subscription';
        if (prev === 'login' || prev === 'register') return 'dashboard';
        return prev;
      });
    }
  }, [user]);

  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-[#09090B]" data-testid="app-loading">
      <div className="text-center animate-fade-in">
        <div className="w-12 h-12 rounded-lg bg-[#8B5CF6] flex items-center justify-center mx-auto mb-3">
          <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
        </div>
        <p className="text-sm text-[#A1A1AA]">Chargement...</p>
      </div>
    </div>
  );

  if (view === 'gallery') {
    return <GalleryPage onBack={() => setView(user && user !== false ? 'dashboard' : 'landing')} isAuthenticated={!!(user && user !== false)} />;
  }
  if (view === 'howItWorks') {
    return <HowItWorksPage onBack={() => setView('landing')} onGetStarted={() => setView('login')} />;
  }
  if (view === 'brief') {
    return <BriefPage onBack={() => setView(user && user !== false ? 'dashboard' : 'landing')} onGetStarted={() => setView('login')} />;
  }

  if (!user || user === false) {
    if (view === 'login') return <LoginPage onSwitchToRegister={() => setView('register')} />;
    if (view === 'register') return <RegisterPage onSwitchToLogin={() => setView('login')} initialPromoCode={inviteCode} />;
    return <LandingPage onGetStarted={() => setView('login')} onGallery={() => setView('gallery')} onHowItWorks={() => setView('howItWorks')} onBrief={() => setView('brief')} />;
  }

  if (view === 'subscription') return <SubscriptionPage onBack={() => { window.history.pushState({}, '', '/'); setView('dashboard'); }} />;
  return <Dashboard onSubscribe={() => setView('subscription')} />;
}

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" toastOptions={{
        style: { background: '#18181B', color: '#F4F4F5', border: '1px solid #27272A', borderRadius: '8px', fontFamily: 'IBM Plex Sans, sans-serif', fontSize: '14px' }
      }} />
      <AppContent />
    </AuthProvider>
  );
}

export default App;
